export default {"src":"/_next/static/media/dropped.05aa880d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};